import request from '../util/request';
import SERVER_URL from '../util/seaver';

// 员工
function userSel(reqData) {
  const reqUrl = SERVER_URL + '/user/sel';
  return request({
    url: reqUrl,
    method: 'POST',
    data: reqData,
  });
}
function userCount(reqData) {
  const reqUrl = SERVER_URL + '/user/count';
  return request({
    url: reqUrl,
    method: 'POST',
    data: reqData,
  });
}
function userAdd(reqData) {
  const reqUrl = SERVER_URL + '/user/add';
  return request({
    url: reqUrl,
    method: 'POST',
    data: reqData,
  });
}
function userDel(reqData) {
  const reqUrl = SERVER_URL + '/user/del';
  return request({
    url: reqUrl,
    method: 'POST',
    data: reqData,
  });
}
function userMod(reqData) {
  const reqUrl = SERVER_URL + '/user/mod';
  return request({
    url: reqUrl,
    method: 'POST',
    data: reqData,
  });
}
function userResetPass(reqData) {
  const reqUrl = SERVER_URL + '/user/resetPass';
  return request({
    url: reqUrl,
    method: 'POST',
    data: reqData,
  });
}
export { userSel, userCount, userAdd, userDel, userMod, userResetPass };
